import { Component } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {environment} from "../environments/environment";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(private activatedRoute: ActivatedRoute){
    this.activatedRoute.params.subscribe(url => {

    });

    if (environment.production) {
      if (window.location.protocol == "http:") {
        window.open(window.location.href.replace("http", "https"), "_self");
      }
    }
  }
}



// WEBPACK FOOTER //
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/app.component.ts